import { OutstreamVideoAd as DisplayAdsOutstreamVideoAd } from '@tunein/display-ads/react';
import PropTypes from 'prop-types';
import { mintSingleton } from 'src/client/mint';
import { DISPLAY_ADS_LIBRARY_ENABLED } from 'src/common/constants/experiments/ads';
import useExperiment from 'src/common/hooks/useExperiment';
import useOnMount from 'src/common/hooks/useOnMount';

const placementName = 'FreeStarVideoAdContainer';

/** The legacy ad client's path: the app renders FreeStar's mount markup and drives the player. */
function LegacyFreeStarVideoAd() {
  useOnMount(() => {
    let isUnmounting = false;

    async function onMount() {
      if (!mintSingleton.isReady) {
        await mintSingleton.readyPromise;
      }

      if (!isUnmounting) {
        mintSingleton.instance?.requestInContentVideo?.(placementName);
      }
    }

    onMount();

    return async () => {
      isUnmounting = true;

      if (!mintSingleton.isReady) {
        await mintSingleton.readyPromise;
      }

      mintSingleton.instance?.deleteInContentVideo?.(placementName);
    };
  });

  return (
    <div id="freestar-video-parent">
      <div id="freestar-video-child" />
    </div>
  );
}

export default function FreeStarVideoAdContainer({ center = false }) {
  const isDisplayAdsLibraryEnabled = useExperiment(DISPLAY_ADS_LIBRARY_ENABLED, false);

  return (
    <div
      id="FreeStarVideoAdContainer"
      style={{ marginTop: '10px', marginBottom: '10px', marginInline: center ? 'auto' : 0 }}
    >
      {isDisplayAdsLibraryEnabled ? <DisplayAdsOutstreamVideoAd /> : <LegacyFreeStarVideoAd />}
    </div>
  );
}

FreeStarVideoAdContainer.propTypes = {
  center: PropTypes.bool,
};
